'use strict';

module.exports = (app) => app.factory('ociBackgroundSearchService', /* @ngInject */ function (apiConfig, httpService) {

    function getCompatibleCatalogs() {
        const uri = apiConfig.getBase('oci', 'getCatalogs');

        return httpService.get(uri.toString(), {isArray: true, cache:true})
    }

    function search(catalogId, query) {
        const uri = apiConfig.getBase('oci', 'search');
        uri.query.searchFor = query;
        uri.query.catalog = catalogId;

        return httpService.get(uri.toString(), {
            cache: true,
        })
    }

    return {
        getCompatibleCatalogs,
        search
    }
})
